import { CT_GAME_SLUG } from '@/constants/game';
import { cartBucket } from '@/constants/game/products';
import { generateCombinations, isArrayEmpty } from '@/utils/utils';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        cart: [],
        cartRender: [],
        quantity: 0,
        transact: [],
        transact645: [],
        transact545: [],
        transact459: [],
        transact480: [],
        transact452: [],
        isLoadingAddCart: false,
        totalCart: 0,
        isScreenMobile: false,
        isLogin: false,
        stepCart: 1,
        isShow590: true,
        isShow480: true,
        isShow452: true,
        isShow645: false,
        isShow545: false,
        isShow459: false,
        CURRENCY: 'CDF',
        playerType: ''
    },
    mutations: {
        SET_DATA_CART(state, data) {
            state.cart = data.cart;
            state.cartRender = data.cartRender;
            state.quantity = data.quantity;
            state.transact = data.transact;
            state.totalCart = data.totalCart;
            state.transact645 = data.transact645;
            state.transact545 = data.transact545;
            state.transact459 = data.transact459;
            state.transact480 = data.transact480;
            state.transact452 = data.transact452;
            state.stepCart = data?.stepCart || state.stepCart
            localStorage.setItem('cart', JSON.stringify(data.cart));
            localStorage.setItem('cartRender', JSON.stringify(data.cartRender));
            localStorage.setItem('quantity', data.quantity);
            localStorage.setItem('transact', JSON.stringify(data.transact));
            localStorage.setItem('totalCart', JSON.stringify(data.totalCart));
            localStorage.setItem('transact645', JSON.stringify(data.transact645));
            localStorage.setItem('transact545', JSON.stringify(data.transact545));
            localStorage.setItem('transact459', JSON.stringify(data.transact459));
            localStorage.setItem('transact480', JSON.stringify(data.transact480 || []));
            localStorage.setItem('transact452', JSON.stringify(data.transact452 || []));
            state.isLoadingAddCart = false;
        },
        SET_DATA_CART_SWITCH(state, data) {
            state.totalCart = data.totalCart;
            state.cartRender = data.cartRender;
            state.stepCart = data.step;
            localStorage.setItem('totalCart', JSON.stringify(data.totalCart));
            localStorage.setItem('cartRender', JSON.stringify(data.cartRender));
            localStorage.setItem('stepCart', JSON.stringify(data.step));
        },
    },
    actions: {
        onSwitchBetslip({ commit, state }, payload) {
            const { step } = payload;
            const cart: any = state.cart;
            const type = cartBucket(step).gameType;

            let cartRender = cart.filter((x) => x.gameType === type);
            let totalCart = cartRender.reduce((a, b) => a + b.price, 0);

            const param = {
                totalCart,
                cartRender,
                step,
            };

            commit('SET_DATA_CART_SWITCH', param);
        },

        onAddToCart({ commit, state }, payload) {
            const cart: any = state.cart;
            let cartRender: any = [];
            const transact: any = state.transact;
            const transact645: any = state.transact645;
            const transact545: any = state.transact545;
            const transact459: any = state.transact459;
            const transact480: any = state.transact480;
            const transact452: any = state.transact452;
            let quantity: number = state.quantity;
            let totalCart: number = 0;
            let title = `${payload.title}`;
            let game = `${payload.game}`;
            let quantityBets = 1;

            if (!payload.isPariMutuelLotto && !payload.preserveSlug) {
                title += ` ${payload.gameNumber}`;
                game += `${payload.gameNumber}`;
            }

            const numberQp = parseInt(payload.numberQp);
            // Get min picks from allowed_picks or numberQp
            const minPicks = payload?.allowed_picks?.min || numberQp;
            
            // Check if this is Extra 6 or Extra 7 (these are NOT combination games)
            const isExtraGame = (title && title.toLowerCase().includes('extra')) || 
                                (game && game.toLowerCase().includes('extra'));
            
            payload.event_id.map((eventId, i) => {
                let isMarkerBoth = Boolean(payload.market_option === 'both')

                // Handle banker mode selections differently
                let selection = payload.selection;
                let selectionCount = 0;
                
                // Component always sends correct format:
                // Normal mode: [[1, 2, 3]]
                // Banker mode: [[10], [38, 39]]
                // So just use it directly
                selection = payload.selection;
                
                // Calculate selection count
                if (Array.isArray(payload.selection) && payload.selection.length > 0 && Array.isArray(payload.selection[0])) {
                    // Nested array - count all balls across all groups
                    selectionCount = payload.selection.reduce((sum, group) => sum + (Array.isArray(group) ? group.length : 0), 0);
                } else {
                    selectionCount = 0;
                }
                
                let item = {
                    id: new Date().getTime().toString(36).concat(performance.now().toString(), Math.random().toString()).replace(/\./g, ''),
                    parentId: payload.id,
                    eventId,
                    eventDate: payload.eventInfo[i].date,
                    eventName: payload.eventInfo[i].name,
                    selection: selection,
                    title,
                    price: payload.wager,
                    bets: 0,
                    selectionCount: selectionCount,
                    isPariMutuelLotto: payload?.isPariMutuelLotto,
                    gameType: payload.gameType || (payload.isPariMutuelLotto ? payload.game : 'loto-590'),
                    market_option: !isMarkerBoth ? payload.market_option : '',
                    banker_option: payload.banker_option || null,
                };

                // For Multi-lotto games (Turbo, Nap, Chance, Chance+) - NOT Pari-mutuel - NOT Extra 6/7
                // Don't calculate combinations for banker mode (already handled differently)
                if (!payload.isPariMutuelLotto && !isExtraGame && !payload.banker_option && selectionCount > minPicks) {
                    quantityBets = generateCombinations(selectionCount, minPicks);
                    item['bets'] = quantityBets;
                    item['combination_play'] = 1; // Flag for permutation bet
                    // Price is already calculated by the selected product wager rules.
                }
                
                // For Pari-mutuel lotto games (Lotto 6/45, 5/45, 4/59)
                if (payload.isPariMutuelLotto && selectionCount > numberQp) {
                    quantityBets = generateCombinations(selectionCount, numberQp);
                    item['price'] = payload.wager * quantityBets;
                    item['bets'] = quantityBets;
                }

                cart.push(item);

                if(isMarkerBoth) {
                    const itemClone = {...item}
                    item['market_option'] = 'double_chance'
                    cart.push(itemClone)
                }
            });

            const isMarkerBoth = Boolean(payload.market_option === 'both')

            // Calculate selection count for permutation detection
            let transactSelectionCount = 0;
            if (Array.isArray(payload.selection) && payload.selection.length > 0 && Array.isArray(payload.selection[0])) {
                transactSelectionCount = payload.selection.reduce((sum, group) => sum + (Array.isArray(group) ? group.length : 0), 0);
            }

            let item = {
                id: payload.id,
                selection: payload.selection, // Component already sends correct format: [[nums]] or [[banker], [other]]
                draws: payload.draws,
                event_id: payload.event_id,
                wager: payload.wager,
                market_option: !isMarkerBoth ? payload.market_option : '',
                game,
            };
            
            // Add selection_type and combination_play for banker bets
            if (payload.banker_option) {
                item['selection_type'] = payload.banker_option;
                item['combination_play'] = 1; // Flag for banker bet (uses perm_wager)
            }
            
            // Add combination_play for permutation bets (Multi-lotto games, NOT Extra 6/7, NOT banker mode)
            const transactMinPicks = payload?.allowed_picks?.min || numberQp;
            if (!payload.isPariMutuelLotto && !isExtraGame && !payload.banker_option && transactSelectionCount > transactMinPicks) {
                item['combination_play'] = 1; // Flag for permutation bet
            }

            let itemClone
            
            if(isMarkerBoth) {
                itemClone = {...item}
                item['market_option'] = 'double_chance'
            }

            let stepCart = payload.productStep || 1
            const entries = {
                transact,
                transact645,
                transact545,
                transact459,
                transact480,
                transact452,
            }
            const bucket = cartBucket(stepCart)
            entries[bucket.field].push(item);
            if(isMarkerBoth) entries[bucket.field].push(itemClone);
            const typeGame = payload.gameType || bucket.gameType;

            cartRender = cart.filter((x) => x.gameType === typeGame);
            totalCart = cartRender.reduce((a, b) => a + b.price, 0);
            quantity = cart.length;

            const param = {
                quantity,
                transact,
                cart,
                totalCart,
                transact645,
                transact545,
                transact459,
                transact480,
                transact452,
                cartRender,
                stepCart,
            };

            commit('SET_DATA_CART', param);
        },
        onRemoveItemCart({ commit, state }, payload) {
            const cart: any = state.cart;
            let cartRender: any = [];
            let transact: any = state.transact;
            let transact645: any = state.transact645;
            let transact459: any = state.transact459;
            let transact545: any = state.transact545;
            let transact480: any = state.transact480;
            let transact452: any = state.transact452;
            let quantity: number = state.quantity;
            let totalCart: number = state.totalCart;
            const element = payload.item;

            let transactClone: any = [];

            if (element.gameType === 'lotto-6-45') {
                transactClone = transact645;
            } else if (CT_GAME_SLUG.LOTTO_459.includes(element.gameType?.toLowerCase())) {
                transactClone = transact459;
            } else if (element.gameType === 'lotto-5-45') {
                transactClone = transact545;
            } else if (element.gameType === 'loto-4-80') {
                transactClone = transact480;
            } else if (element.gameType === 'lotto-axion-4-52') {
                transactClone = transact452;
            } else {
                transactClone = transact;
            }

            const index = transactClone.findIndex((x) => x.id === element.parentId);

            if (index !== -1) {
                transactClone[index].event_id = transactClone[index].event_id.filter((x) => x !== element.eventId);
            }

            if (isArrayEmpty(transactClone[index]?.event_id)) {
                transactClone.splice(index, 1);
            }

            const indexCart = cart.findIndex((x) => x.id === element.id);

            cart.splice(indexCart, 1);

            cartRender = cart.filter((x) => x.gameType === element.gameType);

            totalCart = cartRender.reduce((a, b) => a + b.price, 0);
            quantity = cart.length;
            let param = {
                quantity,
                transact,
                cart,
                totalCart,
                transact459,
                transact545,
                transact480,
                transact452,
                transact645,
                cartRender,
            };

            if (element.gameType === 'lotto-6-45') {
                param['transact645'] = transactClone;
            } else if (CT_GAME_SLUG.LOTTO_459.includes(element.gameType?.toLowerCase())) {
                param['transact459'] = transactClone;
            } else if (element.gameType === 'lotto-5-45') {
                param['transact545'] = transactClone;
            } else if (element.gameType === 'loto-4-80') {
                param['transact480'] = transactClone;
            } else if (element.gameType === 'lotto-axion-4-52') {
                param['transact452'] = transactClone;
            } else {
                param['transact'] = transactClone;
            }

            commit('SET_DATA_CART', param);
        },

        onClearCart({ state, commit }) {
            let cart: any = state.cart;
            const bucket = cartBucket(state.stepCart);
            cart = cart.filter((x) => x.gameType !== bucket.gameType);
            let totalCart = cart.reduce((a, b) => a + b.price, 0);
            let quantity = cart.length;

            let param = {
                quantity,
                transact: state.stepCart === 1 ? [] : state.transact,
                cart: cart,
                totalCart,
                transact645: state.stepCart === 2 ? [] : state.transact645,
                transact459: state.stepCart === 3 ? [] : state.transact459,
                transact545: state.stepCart === 4 ? [] : state.transact545,
                transact480: state.stepCart === 5 ? [] : state.transact480,
                transact452: state.stepCart === 6 ? [] : state.transact452,
                cartRender: [],
            };
            commit('SET_DATA_CART', param);
        },

        // Handle partial transaction results: remove successful items, mark failed ones
        onPartialTransactResult({ state, commit }, payload) {
            const { failedEventIds, successfulEventIds, stepCart } = payload;
            let cart: any = [...state.cart];
            let transact: any = [...state.transact];
            let transact645: any = [...state.transact645];
            let transact459: any = [...state.transact459];
            let transact545: any = [...state.transact545];
            let transact480: any = [...state.transact480];
            let transact452: any = [...state.transact452];

            // Get current transact array based on stepCart
            let currentTransact: any = [];
            const bucket = cartBucket(stepCart);
            if (bucket.field === 'transact') currentTransact = transact;
            else if (bucket.field === 'transact645') currentTransact = transact645;
            else if (bucket.field === 'transact459') currentTransact = transact459;
            else if (bucket.field === 'transact545') currentTransact = transact545;
            else if (bucket.field === 'transact480') currentTransact = transact480;
            else currentTransact = transact452;

            // Remove successful items from cart and mark failed ones
            cart = cart.map((item) => {
                if (successfulEventIds.includes(item.eventId)) {
                    return null; // Mark for removal
                }
                if (failedEventIds.includes(item.eventId)) {
                    return { ...item, failed: true }; // Mark as failed
                }
                return item;
            }).filter(Boolean); // Remove null items

            // Remove successful transact entries (those with event_id matching successful ones)
            currentTransact = currentTransact.filter((item) => {
                const hasSuccessfulEvent = item.event_id?.some((eid) => successfulEventIds.includes(eid));
                if (hasSuccessfulEvent) {
                    // Remove successful event_ids from this transact item
                    item.event_id = item.event_id.filter((eid) => !successfulEventIds.includes(eid));
                    return item.event_id.length > 0; // Keep only if there are remaining events
                }
                return true;
            });

            // Determine game type for cartRender
            let type = bucket.gameType;
            if (bucket.field === 'transact') transact = currentTransact;
            else if (bucket.field === 'transact645') transact645 = currentTransact;
            else if (bucket.field === 'transact459') transact459 = currentTransact;
            else if (bucket.field === 'transact545') transact545 = currentTransact;
            else if (bucket.field === 'transact480') transact480 = currentTransact;
            else transact452 = currentTransact;

            let cartRender = cart.filter((x) => x.gameType === type);
            let totalCart = cartRender.reduce((a, b) => a + b.price, 0);
            let quantity = cart.length;

            let param = {
                quantity,
                transact,
                cart,
                totalCart,
                transact645,
                transact459,
                transact545,
                transact480,
                transact452,
                cartRender,
            };
            commit('SET_DATA_CART', param);
        },
    },
});
